<template>
    <div class="container">
        <md-dialog :md-active.sync="modCrearTasa" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.tipoTasa}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <select v-model="tipoTasa" class="form-control">
                            <option value="">{{ labels.select }}</option>
                            <option v-for="tipoTasa in listTipoTasa" :key="tipoTasa.id" :value="tipoTasa.tipo_tasa">{{ tipoTasa.descripcion }}</option>
                        </select>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.valor}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="valor" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.vigencia}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="date" v-model="vigencia" class="form-control">
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <md-button class="md-primary" @click="guardarTasa">{{ labels.save }}</md-button>
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import TipoTasas from '../../../services/TipoTasas';
import Tasa from '../../../services/Tasas';

export default {
    name : 'Crear',
    props: ['modCrearTasa'],
    data: () => ({
        listTipoTasa : [],
        tipoTasa : '',
        valor : null,
        vigencia : ''
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Crear tasas',
                    save : 'Guardar',
                    close : 'Cerrar',
                    select : 'Seleccione...',
                    tipoTasa : 'Tipo tasa',
                    valor : 'Valor',
                    vigencia : 'Vigencia',
                }
            }else{
                return {
                    title : 'Create rates',
                    save : 'Save',
                    close : 'Close',
                    select : 'Select...',
                    tipoTasa : 'Rate type',
                    valor : 'Worth',
                    vigencia : 'Validity',
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        guardarTasa(){
            const dataForm = [
                this.tipoTasa,
                this.valor,
                this.vigencia
            ]

            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{
                let info = {
                    'tipoTasa' : this.tipoTasa,
                    'valor' : this.valor,
                    'vigencia' : this.vigencia,
                    'idUser' : this.$store.state.userId
                }
                // console.log(info);
                Tasa.createTasa(info)
                .then((res) => {
                    if(res.status == 201){
                        this.$toast.success(res.data.message)
                        location. reload()
                    }
                })
                .catch((err) => console.log(err))
            }
        }
    },
    mounted(){
        TipoTasas.getAllTipoTasas()
        .then((res) => {
            // console.log(res.data.listTipoTasas);
            this.listTipoTasa = res.data.listTipoTasas
        })
        .catch((err) => { console.log(err) })
    }
}
</script>

<style>

</style>